import React, {
  Component,
  useRef,
  useState,
  useEffect,
  useCallback,
} from "react";
import { Form, Icon } from "semantic-ui-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert";

import * as yup from "yup";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import {
  Container,
  Title,
  Field,
  Label,
  Input,
  InputFile,
  Select,
  Textarea,
  Button,
} from "./styled";
import { isAuthAdmin } from "../../../../services/auth";
import { producaov2 as api } from "../../../../services/apis";
import { useRouter } from "../../../../hooks/router";

toast.configure();
const CriarDepoimento = () => {
  const [treinamento, setTreinamento] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedImageUrl, setSelectedImageUrl] = useState("");
  const [selectedVideo, setSelectedVideo] = useState("");
  const [selectedVideoUrl, setSelectedVideoUrl] = useState("");
  const [area, setArea] = useState([]);
  const [depoimento, setDepoimento] = useState({
    aluno: "",
    ativo: "S",
    foto: "",
    video: "",
    texto: "",
    id_area: "",
    id_treinamento: "",
  });

  const router = useRouter();

  useEffect(() => {
    loadAuth();
    api
      .get(`treinamentos`)
      .then((res) => {
        setTreinamento([...treinamento, ...res.data]);

        setDepoimento((depoimento) => ({
          ...depoimento,
          id_treinamento: res.data[0].id,
        }));
      })
      .catch((err) => {
        swal("Não foi possível carregar os treinamentos", err, "");
      });

    api
      .get(`area`)
      .then((res) => {
        setArea([...area, ...res.data]);

        setDepoimento((depoimento) => ({
          ...depoimento,
          id_area: res.data[0].id,
        }));
      })
      .catch((err) => {
        swal("Não foi possível carregar as areas", err, "");
      });
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };
  const handleSelectedImage = useCallback((e) => {
    const { files } = e.target;

    if (!files[0].type.includes("image")) {
      toast.error("Por favor, insira uma imagem", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    const objectURL = URL.createObjectURL(files[0]);
    setSelectedImageUrl(objectURL);
    setSelectedImage(files[0]);
  });

  const handleSelectedVideo = useCallback((e) => {
    const { files } = e.target;

    if (!files[0].type.includes("video")) {
      toast.error("Por favor, insira uma vídeo", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    const objectURL = URL.createObjectURL(files[0]);
    setSelectedVideoUrl(objectURL);
    setSelectedVideo(files[0]);
  });

  const uploadImage = async () => {
    try {
      const inputData = new FormData();

      inputData.append("file", selectedImage);
      inputData.append("path", "imagens-voitto/depoimentos/imagens");

      const response = await api.post("/upload", inputData);
      const { url } = response.data;

      toast.success("O Upload da Foto foi concluido com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      return url;
    } catch (err) {
      toast.error(
        "O Upload da Foto falhou, verifique o arquivo e tente novamente",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  };
  const uploadVideo = async () => {
    try {
      const formData = new FormData();

      formData.append("file", selectedVideo);
      formData.append("path", "imagens-voitto/depoimentos/videos");

      const linkToMidia = await api.post("/upload", formData);

      toast.success("O upload do video foi concluido com sucesso!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      return linkToMidia.data.url;
    } catch (err) {
      toast.error(
        "o upload do video falhou, verifique o arquivo e tente novamente",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
    }
  };

  const handleSubmit = useCallback(() => {
    const depoimentoValidation = yup.object().shape({
      id_area: yup
        .number("Necessário que informe a area")
        .required("Necessário que informe a area"),
      id_treinamento: yup
        .number("Necessário que informe o treinamento")
        .required("Necessário que informe o treinamento"),
      aluno: yup
        .string("Necessário que informe o nome do aluno")
        .required("Necessário que informe o nome do aluno"),
      foto: yup.string("Necessário que informe a foto do aluno"),
      video: yup.string("Necessário que informe o video do depoimento"),
      texto: yup
        .string("Necessário que informe o texto do depoimento")
        .required("Necessário que informe a texto do depoimento"),
      ativo: yup
        .string("Necessário que informe se o depoimento está ativo")
        .required("Necessário que informe se o depoimento está ativo"),
    });

    depoimentoValidation
      .validate(depoimento, { abortEarly: true })
      .then(async () => {
        try {
          if (selectedImage) {
            depoimento.foto = await uploadImage();
          }

          if (selectedVideo) {
            depoimento.video = await uploadVideo();
          }

          await api.post(`admin/pessoa/depoimentos`, depoimento).then(async (res) => {
            let array = {
              local: "depoimento",
              texto: `criou o depoimento de id= ${res.data.depoimento.id}`,
            };
            await api.post("system_logs", { acao: JSON.stringify(array) });
          });

          setTimeout(() => router.push("/admin/depoimentos"), 2500);

          toast.success("Depoimento criado com sucesso!", {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        } catch (err) {
          console.log("error", err);

          toast.error("Ops, houve um erro no cadastro!", {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
      })
      .catch((err) => {
        console.error(err);

        toast.error("Ops, houve um erro no formato dos campos!", {
          position: "bottom-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });
  }, [depoimento, selectedVideo, selectedImage, router]);

  return (
    <>
      <AdminMenu />
      <Container>
        <Title>Criar Depoimento</Title>

        <Form>
          <Field>
            <Label>Nome do Aluno</Label>
            <Input
              type="text"
              placeholder="Nome do Aluno"
              name="nome"
              onChange={(e) =>
                setDepoimento({ ...depoimento, aluno: e.target.value })
              }
            />
          </Field>
          <Field>
            <Label>Foto do Aluno</Label>
            <InputFile
              type="file"
              name="link_yout"
              onChange={handleSelectedImage}
            />

            {!selectedImage && depoimento.foto && <img src={depoimento.foto} />}

            {selectedImage && <img src={selectedImageUrl} />}
          </Field>
          <Field>
            <Label>Área</Label>
            <Select
              name="area"
              onChange={(e) =>
                setDepoimento({ ...depoimento, id_area: e.target.value })
              }
            >
              {area.map((option) => (
                <option value={option.id}>{option.nome}</option>
              ))}
            </Select>
          </Field>
          <Field>
            <Label>Treinamento</Label>
            <Select
              name="area"
              onChange={(e) =>
                setDepoimento({ ...depoimento, id_treinamento: e.target.value })
              }
            >
              {treinamento.map((option) => (
                <option value={option.id}>{option.nome}</option>
              ))}
            </Select>
          </Field>

          <Field>
            <Label>Texto</Label>
            <Textarea
              cols={10}
              role={10}
              name="parafrase"
              onChange={(e) =>
                setDepoimento({ ...depoimento, texto: e.target.value })
              }
            />
          </Field>

          <Field>
            <Label>Vídeo</Label>
            <InputFile
              type="file"
              name="link_yout"
              onChange={handleSelectedVideo}
            />

            {!selectedVideo && depoimento.video && (
              <video controls style={{ width: "50%" }} src={depoimento.video} />
            )}

            {selectedVideo && (
              <video controls style={{ width: "50%" }} src={selectedVideoUrl} />
            )}
          </Field>
          <Button type="submit" onClick={handleSubmit}>
            <Icon name="save" />
            Salvar
          </Button>
        </Form>
      </Container>
    </>
  );
};
export default CriarDepoimento;
